(function (d, w) {
  var articleContent = d.querySelector(".template-article-content");
  if (!articleContent) return;

  var allH2 = articleContent.querySelectorAll("h2");
  if (!allH2 || allH2.length === 0) {
    var articleTOCElement = document.querySelector(".article-header-row-toc");
    if (articleTOCElement) {
      articleTOCElement.remove();
    }

    return;
  }
  var H2Count = allH2.length;
  var extraScrollSpacing = 200;

  const scrollToElement = (ele) => {
    var scrollY = Math.ceil(
      ele.getBoundingClientRect().y + w.scrollY - extraScrollSpacing
    );

    w.scrollTo({
      top: scrollY,
      behaviour: "smooth",
    });

    setTimeout(() => {
      scrollCallback();
    }, 350);
  };

  var stickyButtons = [];

  const renderTOC = () => {
    var template = d.querySelector("#Article-toc-content");
    var placeholder = d.querySelector("[data-toc-placeholder]");
    if (!template || !placeholder) return;

    var H2Threshold = 4;
    var aboveThreshold = H2Count > H2Threshold;
    var bodyQueryString = "[data-toc-below-threshold]";

    if (aboveThreshold) {
      bodyQueryString = "[data-toc-above-threshold]";
    }

    var TOCContainer = template.content
      .querySelector(bodyQueryString)
      .cloneNode(true);
    var TOCContentBody =
      TOCContainer.querySelector(".toc-body") ||
      TOCContainer.querySelector(".toc-dropdown-body");
    var TOCContentExpanded = TOCContainer.querySelector("[dropdown-content]");
    var itemReference = template.content.querySelector("[data-toc-item]");

    var TOCStickyBody = d.querySelector("[data-sticky-toc-body]");

    allH2.forEach((h2, index) => {
      var item = itemReference.cloneNode(true);
      var itemLabel = item.querySelector("span");

      itemLabel.textContent = h2.textContent;

      item.addEventListener("click", () => scrollToElement(h2));

      if (TOCStickyBody) {
        var stickyItem = d.createElement("button");
        stickyItem.classList.add("pill");

        stickyItem.innerHTML = `<span>${h2.textContent}</span>`;

        stickyItem.addEventListener("click", () => scrollToElement(h2));

        stickyButtons.push(stickyItem);

        TOCStickyBody.appendChild(stickyItem);
      }

      if (index >= H2Threshold) {
        TOCContentExpanded.appendChild(item);
        return;
      }

      TOCContentBody.appendChild(item);
    });

    placeholder.appendChild(TOCContainer);
  };
  renderTOC();

  var nav = document.querySelector("header-nav");
  var navRect;

  const navigationRect = () => {
    if (!navRect) {
      if (nav) {
        nav = nav;
        navRect = nav.getBoundingClientRect();
      }
    }

    if (nav) {
      var currentRect = nav.getBoundingClientRect();
      if (navRect.bottom !== currentRect.bottom) {
        navRect = currentRect;
      }
    }

    return navRect.bottom || 0;
  };

  let stickyButtonContainer = d.querySelector("[data-sticky-toc-body]");

  const setActiveStickyButton = (btn) => {
    if (!btn) {
      return;
    }
    if (btn.classList.contains("blogfilter-active")) {
      return;
    }

    if (!btn.classList.contains("blogfilter-active")) {
      let left = btn.offsetLeft;
      stickyButtonContainer.scrollTo({
        left: left,
        behavior: "smooth",
      });

      stickyButtons.forEach((btn) => btn.classList.remove("blogfilter-active"));
      btn.classList.add("blogfilter-active");
    }
  };

  const scrollCallback = () => {
    var scrollThreshold = navigationRect() + extraScrollSpacing;

    let closestChapter;
    let index;

    allH2.forEach((h2, idx) => {
      let rectTop = h2.getBoundingClientRect().top;

      if (scrollThreshold >= rectTop) {
        if (!closestChapter) {
          index = idx;
          closestChapter = {
            node: h2,
            top: rectTop,
          };
          return;
        }

        if (rectTop >= closestChapter.top) {
          index = idx;
          closestChapter = {
            node: h2,
            top: rectTop,
          };
        }
      }
    });

    setActiveStickyButton(stickyButtons[index]);
  };

  let throttleDelay = 100;
  const scrollThrottle = () => {
    let time = Date.now();

    return () => {
      if (time + throttleDelay - Date.now() <= 0) {
        scrollCallback();
        time = Date.now();
      }
    };
  };

  w.addEventListener("scroll", scrollThrottle());
  d.addEventListener("DOMContentLoaded", scrollCallback);

  const goToConclusion = () => {
    var scrollToTarget = allH2[allH2.length - 1];

    var matchSpellingTag = d.querySelector("[data-find-conclusion]");
    if (matchSpellingTag) {
      var matchSpelling = JSON.parse(
        matchSpellingTag.textContent
      )?.match_spelling;

      if (matchSpelling.includes("Translation missing")) {
        var matchSpelling = undefined;
      }

      if (matchSpelling) {
        var matchingH2 = Array.from(allH2).find(
          (h2) => h2.textContent.toLowerCase() === matchSpelling.toLowerCase()
        );

        if (matchingH2) {
          scrollToTarget = matchingH2;
        }
      }
    }
    var h2WithHTMLTag = Array.from(allH2).find((h2) =>
      h2.querySelector("span.data-conclusion")
    );
    if (h2WithHTMLTag) {
      h2WithHTMLTag.querySelector("span.data-conclusion").remove();
      scrollToTarget = h2WithHTMLTag;
    }
    var btn = d.querySelector("[data-article-conclusion-btn]");
    if (!btn) return;

    btn.addEventListener("click", () => {
      scrollToElement(scrollToTarget);
    });
  };

  const goToSolution = () => {
    var scrollToTarget = d.querySelector(".article-products-content");
    var btn = d.querySelector("[data-article-solution-btn]");
    if (!btn || !scrollToTarget) return;

    btn.addEventListener("click", () => {
      scrollToElement(scrollToTarget);
    });
  };

  goToConclusion();
  goToSolution();
})(document, window);

class QuizTeaser extends HTMLElement {
  constructor() {
    super();
  }

  loadContents() {
    this.reqURL =
      Shopify.routes.root + "pages/" + this.getAttribute("data-page");
    this.reqURL += "?sections=article-quiz-teaser";

    fetch(this.reqURL)
      .then((res) => res.json())
      .then((resJSON) => {
        var htmlContents = resJSON["article-quiz-teaser"];

        this.innerHTML = htmlContents;
      });
  }

  connectedCallback() {
    this.loadContents();
  }
}


customElements.define('quiz-teaser', QuizTeaser);